import classNames from 'classnames';
import { useId } from 'react';
import type { CheckboxProps } from './checkbox';
import { Checkbox } from './checkbox';

type CheckboxLabelledProps = CheckboxProps & {
  label: string;
};
export function CheckboxLabelled({ label, value, className, disabled, onValueChange }: CheckboxLabelledProps) {
  const id = useId();
  return (
    <div className={classNames('flex flex-row align-middle gap-100', className)}>
      <Checkbox id={id} value={value} disabled={disabled} onValueChange={onValueChange} />
      <label htmlFor={id} className={classNames('tds-input-value tds-input-value-default tds-checkbox-label', { disabled: disabled })}>{label}</label>
    </div>
  );
}
